import { ReactElement } from 'react';

export const StreamlinesReports = ({ fill, stroke }: any): ReactElement => {
  return (
    <svg x="0px" y="0px" width={'24px'} height={'24px'} viewBox="0 0 24 24">
      {/* Chart bars */}
      <rect
        x="3"
        y="14"
        width="3"
        height="6"
        stroke={stroke ?? 'currentColor'}
        fill={fill ?? 'currentColor'}
        strokeWidth="0.5"
        rx="0.5"
      />
      <rect
        x="7"
        y="10"
        width="3"
        height="10"
        stroke={stroke ?? 'currentColor'}
        fill={fill ?? 'currentColor'}
        strokeWidth="0.5"
        rx="0.5"
      />
      <rect
        x="11"
        y="6"
        width="3"
        height="14"
        stroke={stroke ?? 'currentColor'}
        fill={fill ?? 'currentColor'}
        strokeWidth="0.5"
        rx="0.5"
      />
      <rect
        x="15"
        y="8"
        width="3"
        height="12"
        stroke={stroke ?? 'currentColor'}
        fill={fill ?? 'currentColor'}
        strokeWidth="0.5"
        rx="0.5"
      />
      <rect
        x="19"
        y="12"
        width="3"
        height="8"
        stroke={stroke ?? 'currentColor'}
        fill={fill ?? 'currentColor'}
        strokeWidth="0.5"
        rx="0.5"
      />

      {/* Document outline */}
      <path d="M2 2h20v20H2z" stroke={stroke ?? 'currentColor'} fill="none" strokeWidth="0.5" rx="1" />
    </svg>
  );
};
